import * as React from 'react';
import { connect } from 'react-redux';
import { photoCaptureDeleteAttachmentsAction, photoCaptureIntelligentDeleteAllAttachmentIterationsAction, photoCaptureIntelligentEstimatorGalleryImageDeleteAction, photoCaptureIntelligentEstimatorGalleryImageReplacementAction, photoCaptureIntelligentEstimatorGalleryResetAction, photoCaptureIntelligentResetSaveCapturedPhotoAction, photoCaptureIntelligentViewChangeAction, resetIntelligentPhotoCaptureToastAction, showIntelligentPhotoCaptureToastAction } from '../actions';
import { IntelligentPhotoCaptureEstimatorThumbnailGallery } from '../components';
import { getIntelligentCapturedPhotoFile, getIntelligentEstimatorThumbnailGalleryAttachments, getIntelligentEstimatorThumbnailGalleryDeletedAttachments, getIntelligentEstimatorThumbnailGalleryUploadAttachments, getIsConfidence, getPhotoCaptureAttachmentInfo, getPhotoCaptureCompanyCode, getPhotoCaptureContextId, getPhotoCaptureCountryCode, getPhotoCaptureEvaluationDocId, getPhotoCaptureFileSizeLimit, getPhotoCaptureIsTermsAndConditionAccepted, getPhotoCapturePrtcDetailsData, getPhotoCaptureTempAttachmentInfo, getPhotoCaptureUserVehicleInfo, getPhotoCaptureVehicle } from '../selectors';
import { ConnectedIntelligentAssignmentSummaryToastComponent } from './ConnectedIntelligentAssignmentSummaryToastComponent';
const mapStateToProps = (state) => ({
    capturedPhoto: getIntelligentCapturedPhotoFile(state),
    companyCode: getPhotoCaptureCompanyCode(state),
    contextId: getPhotoCaptureContextId(state),
    countryCode: getPhotoCaptureCountryCode(state),
    evaluationDocId: getPhotoCaptureEvaluationDocId(state),
    fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
    galleryAttachments: getIntelligentEstimatorThumbnailGalleryAttachments(state),
    galleryDeletedAttachments: getIntelligentEstimatorThumbnailGalleryDeletedAttachments(state),
    galleryUploadAttachments: getIntelligentEstimatorThumbnailGalleryUploadAttachments(state),
    isConfidence: getIsConfidence(state),
    isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
    photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
    prtcDetailsData: getPhotoCapturePrtcDetailsData(state),
    tempAttachmentInfo: getPhotoCaptureTempAttachmentInfo(state),
    userVehicleInfo: getPhotoCaptureUserVehicleInfo(state),
    vehicle: getPhotoCaptureVehicle(state)
});
const mapDispatchToProps = (dispatch) => ({
    onDeleteAttachments: (deleteAttachmentInfo, contextId, companyCode) => {
        dispatch(photoCaptureDeleteAttachmentsAction(deleteAttachmentInfo, contextId, companyCode));
    },
    onDeleteAllAttachmentIterations: () => {
        dispatch(photoCaptureIntelligentDeleteAllAttachmentIterationsAction());
    },
    onDeleteGalleryAttachment: (galleryAttachment) => {
        dispatch(photoCaptureIntelligentEstimatorGalleryImageDeleteAction(galleryAttachment));
    },
    onUploadGalleryAttachment: (galleryAttachment) => {
        dispatch(photoCaptureIntelligentEstimatorGalleryImageReplacementAction(galleryAttachment));
    },
    onResetGalleryAttachment: () => {
        dispatch(photoCaptureIntelligentEstimatorGalleryResetAction());
    },
    onResetToast: () => {
        dispatch(resetIntelligentPhotoCaptureToastAction());
    },
    onViewChange: (view, sequenceScreenName, selectedTileId) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName, selectedTileId));
    },
    onResetCapturedPhoto: () => {
        dispatch(photoCaptureIntelligentResetSaveCapturedPhotoAction());
    },
    onShowToast: (operationType, toastType, customMessage) => {
        dispatch(showIntelligentPhotoCaptureToastAction(operationType, toastType, customMessage));
    }
});
const ConnectedIntelligentPhotoCaptureEstimatorThumbnailGalleryWrapper = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(IntelligentPhotoCaptureEstimatorThumbnailGallery, Object.assign({}, props, { estimatorWorker: props.estimatorWorker })),
        React.createElement(ConnectedIntelligentAssignmentSummaryToastComponent, null)));
};
export const ConnectedIntelligentPhotoCaptureEstimatorThumbnailGallery = connect(mapStateToProps, mapDispatchToProps)(ConnectedIntelligentPhotoCaptureEstimatorThumbnailGalleryWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureEstimatorThumbnailGallery.js.map